import { TipsMapType } from '../index';

export const realtimeOpinionsTips: TipsMapType = {
  en: "The game data is in the $UTC time zone. As data from the previous hour is still being crawled, the data for the last hour may show a drop or decrease. It's recommended to select the period up to one hour before the current time.",
  zh: '该游戏数据为 $UTC 时区；由于上1小时数据持续爬取中，最近1小时数据可能出现掉0或减少的情况，建议查看周期选至当前时间前1小时。'
};

export const realtimeOptionsKeywordHourly: TipsMapType = {
  en: 'Keywords with a growth rate exceeding 80% compared to the previous hour are recorded as Rising Keywords for the current hour.',
  zh: '当前小时相较于上一小时增量大于80%则记为突增'
};

export const realtimeOptionsKeywordDaily: TipsMapType = {
  en: 'Keywords with a growth rate exceeding 80% compared to the previous day are recorded as Rising Keywords for the current day.',
  zh: '当日相较于上一日增量大于80%的记为突增'
};

export const realtimeOpinionLastHourTips: TipsMapType = {
  en: 'The data has been mostly imported, and the change rate is relatively reliable.',
  zh: '数据基本入库完毕，同环比数据较为可靠'
};

export const realtimeOpinionCurrHourTips: TipsMapType = {
  en: 'Except for Steam, the remaining data is still being crawled, and the change rate is unreliable.',
  zh: '除了steam外，其余数据仍在入库中，同环比数据不可靠'
};

export const realtimeOpinionMentionsTips: TipsMapType = {
  en: 'Summary of the number of Reviews (Posts & Comments). This includes all reviews of the game in the Game Store, as well as reviews captured on Social Media through monitor keywords and official accounts.',
  zh: '全网抓取到的玩家帖子和评论数汇总。包括游戏在游戏商店下的所有评论，以及通过监控词和官号在社交媒体上抓取到的评论。'
};

export const realtimeOpinionHourlyAddedMentionsTips: TipsMapType = {
  en: 'The number of new mentions added within the current time frame in the past hour.',
  zh: '当前时间范围内，最近一小时的声量新增值'
};

export const realtimeOpinionHourlyNegativeMentionsTips: TipsMapType = {
  en: 'The percentage of negative mentions within the newly added mentions in the past hour, within the current time frame.',
  zh: '当前时间范围内，最近一小时的新增声量中，负面声量的占比'
};

export const realtimeOpinionDailyDiscussPlayerTips: TipsMapType = {
  en: 'The number of unique players engaging in discussions (e.g., comments, posts) within the current time frame on a daily basis.',
  zh: '每日参与评论、互动的去重用户数'
};

export const realtimeOpinionHourlyAddedMentionsAverageTips: TipsMapType = {
  en: 'The average number of mentions per hour for each of the 24 hours within the selected day.',
  zh: '所选日内24h每小时的声量的平均值'
};

export const realtimeOpinionHourlyNegativeMentionsAverageTips: TipsMapType = {
  en: 'The average proportion of negative mentions per hour for each of the 24 hours within the selected day.',
  zh: '所选日内24h每小时的负面声量占比的平均值'
};

export const realtimeOpinionHeaderTips: TipsMapType = {
  en: `Due to the data processing logic, this page only supports real-time analysis with a single day as the granularity. If you need to analyze the indicator data for any hour, please go to sections such as "Key Metrics" and "Steam Ratings".`,
  zh: '由于数据处理逻辑，该页面仅支持单日为粒度的实时分析，如需分析任意小时的指标数据，请前往“核心指标”、“Steam商店评分”等板块。',
};